import { extendTheme } from '@chakra-ui/react';
import styles from './styles';
import foundations from './foundations';
import components from './components';

const overrides = {
  fonts: {
    heading: 'Museo Sans, museo-sans, sans-serif',
    body: 'Museo Sans, museo-sans, sans-serif',
  },
  ...foundations,
  components,
  styles,
};

export default extendTheme(overrides);
